/**
 * DevExtreme (esm/__internal/scheduler/appointments/m_render.js)
 * Version: 23.1.5
 * Build date: Wed Aug 30 2023
 *
 * Copyright (c) 2012 - 2023 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import $ from "../../../core/renderer";
import {
    utils
} from "../../../ui/scheduler/utils";
import dxrAppointmentLayout from "../../../renovation/ui/scheduler/appointment/layout.j";
export var renderAppointments = options => {
    var {
        instance: instance,
        $dateTable: $dateTable,
        viewModel: viewModel
    } = options;
    var container = getAppointmentsContainer($dateTable);
    utils.renovation.renderComponent(instance, container, dxrAppointmentLayout, "renovatedAppointments", viewModel)
};
var getAppointmentsContainer = $dateTable => {
    var container = $(".dx-appointments-container");
    if (0 === container.length) {
        container = $("<div>").addClass("dx-appointments-container").appendTo($dateTable)
    }
    return container
};
